import * as _Likes from "./me/likes";
export { _Likes as Likes };
import * as _Notifications from "./me/notifications";
export { _Notifications as Notifications };
import * as _Playlists from "./me/playlists";
export { _Playlists as Playlists };
import * as _Profile from "./me/profile";
export { _Profile as Profile };
import * as _WatchLater from "./me/watch-later";
export { _WatchLater as WatchLater };
import * as _Community from "./me/community";
export { _Community as Community };
import * as _Facebook from "./me/facebook";
export { _Facebook as Facebook };
import * as _PointSystem from "./me/point-system";
export { _PointSystem as PointSystem };
export var Paths;

(function (Paths) {
  Paths["SendEmailVerification"] = "/me/send_email_verification";
  Paths["Sync"] = "/me/sync";
  Paths["GetRecommended"] = "/me/recommended";
  Paths["ListSubscriptions"] = "/me/subscriptions";
  Paths["ListWatchHistory"] = "/me/watch_history";
})(Paths || (Paths = {}));